import { render, staticRenderFns } from "./EdTwitchDestination.vue?vue&type=template&id=f29bf810&"
import script from "./EdTwitchDestination.vue?vue&type=script&lang=js&"
export * from "./EdTwitchDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports